<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 list-menu"
				:class="{ 'menu-active': $route.path == m.url }"
				@click="goTo(m.url)" v-for="m in menu">
				<md-icon style="margin-right: 15px">{{m.icon}}</md-icon>
				<span>{{$store.state.lang.text[m.name][$store.state.lang.language]}}</span>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 list-menu menu-logout" @click="showLogoutDialog()">
				<md-icon style="margin-right: 15px">logout</md-icon>
				<span>{{$store.state.lang.text.logout[$store.state.lang.language]}}</span>
			</div>
		</div>
		<Confirm :active.sync="confirmActive" :title.sync="$store.state.lang.text.logout_confirm[$store.state.lang.language]" @onCancel="cancelLogout" @onConfirm="confirmLogout" />
	</div>
</template>

<script>
	import Confirm from '@/components/Confirm.vue'

	export default {
		components: {
			Confirm
		},
		mounted() {
			window.scrollTo(0,0);
		},
		watch: {
			'$store.state.authentication.loggedIn': function() {
				if(!this.$store.state.authentication.loggedIn) {
					this.$router.push("/login");
				}
			},
		},
		created() {
			if (!this.$store.state.authentication.loggedIn) {
				this.$router.push("/login");
			}
		},
		methods: {
			showLogoutDialog() {
				this.confirmActive = true;
				// this.confirmTitle = "តើអ្នកពិតជាចង់ចាកចេញមែនឬ ?";
			},
			cancelLogout() {
				this.confirmActive = false;
			},
			confirmLogout() {
				this.logout();
			},
			goTo(url) {
				this.$router.push(url);
			},
			logout() {
				this.$store.state.authentication.loggedIn = false;
				this.$store.state.authentication.authToken = null;
				this.$store.state.authentication.username = null;
				this.$cookie.delete('auth');
				this.$cookie.delete('username');
				this.$notification.notify(this.$store.state.lang.text.logout_success[this.$store.state.lang.language]);
			}
		},
		computed: {
		},
		data() {
			return {
				confirmActive: false,
				menu: [
					{name: "account_info", url:"/account", icon: "person"},
					{name: "balance_info", url:"/account/balance", icon: "account_balance_wallet"},
					// {name: "my_promotion", url:"/account/promotions", icon: "redeem"},
					{name: "change_password", url:"/account/change_password", icon: "lock"},
					{name: "deposit", url:"/account/deposit", icon: "payments"},
					{name: "withdraw", url:"/account/withdraw", icon: "credit_card"},
					{name: "transaction", url:"/account/transaction", icon: "receipt_long"},
					// {name: "ចាកចេញ", url:"/account/"},
				],
				isValid: false,
				loaded: false,
				message: "",
				user: {username: "", password: "", token: "", verification_code: "", code: ""}
			}
		}
	}
</script>
<style>
.list-menu {
	cursor:pointer;
	background-color: #103037;
	border-radius: 15px;
	padding: 15px;
	margin-bottom: 15px;
}
.menu-active {
	background-color: #135F87;
}
.menu-logout {
	background-color: #EA5455;
	/* margin-bottom: 0px !important; */
}
@media (min-width: 601px) and (max-width: 944px) {
	.list-menu:nth-child(odd) {
		min-width: calc(50% - 15px) !important;
		max-width: calc(50% - 15px) !important;
		margin-right: 15px !important;
	}
}
.account-container {
		display: flex;
		flex-direction: row;
		margin-bottom: 15px;
		overflow-x: scroll;
}
.account-provider-active {
	background-color: #135F87;
}
.account-provider {
	cursor: pointer;
	white-space: nowrap;
	margin-right: 8px;
	border: 1px solid #135F87;
	border-radius:15px;
	text-align: center;
	justify-content: center;
	align-items: center;
	padding: 8px 12px;
	margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Menu.vue